module.exports = __webpack_public_path__ + "assets/nextmini.7846c293.svg";